import { useEffect, useState } from 'react';
import axios from 'axios';

export default function MaintenanceDialog() {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      retryStatusCheck();
    }
  }, [countdown]);

  async function retryStatusCheck() {
    try {
      const res = await axios.get('/api/status');
      if (res.data.status === 'ok') {
        window.dispatchEvent(new CustomEvent('maintenance', { detail: 'stop' }));
        window.__MAINTENANCE_MODE__ = false;
      } else {
        setCountdown(30);
      }
    } catch (err) {
      console.error('Retry failed.');
      setCountdown(30);
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center z-50 animate-fadeIn">
      <h2 className="text-white text-3xl mb-4 animate-bounce">🚧 Server Maintenance</h2>
      <p className="text-white text-lg">  We're currently performing scheduled maintenance. We'll be back shortly — thanks for bearing with us!</p>
    
      {/* <p className="text-white text-lg">Trying to reconnect in {countdown} second{countdown !== 1 ? 's' : ''}...</p> */}
    </div>
  );
}
